// Geometria vertical da impressão térmica e ajuste de altura por cliente.
//
// O ajuste é um deslocamento em px somado aos dois padding-top padrão (chassi e BRASIL),
// então os dois sobem ou descem juntos e o vão entre eles não muda — o MedidorImpressao
// continua valendo. É configurado pelo admin no cadastro do cliente (colunas
// `ajusta_altura_termica` e `altura_termica_ajuste` da tabela `usuarios`).
//
// Os limites são os mesmos da constraint `usuarios_altura_termica_ajuste_faixa`
// (supabase/sql/2026-09-16_altura_termica.sql). Mudou aqui, mude lá.

export const TOPO_CHASSI_TERMICA_PX = 48;            // chassi sem BRASIL
export const TOPO_CHASSI_TERMICA_COM_BRASIL_PX = 34; // chassi com BRASIL
export const TOPO_BRASIL_TERMICA_PX = 71;

export const AJUSTE_ALTURA_TERMICA_MIN = -40;
export const AJUSTE_ALTURA_TERMICA_MAX = 40;

// 96 px por polegada (25,4 mm) — mesma base de conversão do MedidorImpressao
export const pxParaMm = (px: number): number => (px * 25.4) / 96;

// Aceita qualquer entrada (URL, banco) e devolve um inteiro dentro da faixa; inválido vira 0
export const normalizarAjusteAlturaTermica = (valor: unknown): number => {
  const numero = Math.round(Number(valor));
  if (!Number.isFinite(numero)) return 0;
  return Math.min(AJUSTE_ALTURA_TERMICA_MAX, Math.max(AJUSTE_ALTURA_TERMICA_MIN, numero));
};
